export const GET_STOCK_BALANCE_BYSTOCK = "GET_STOCK_BALANCE_BYSTOCK"
export const GET_STOCK_BALANCE_BYSTOCK_SUCCESS = "GET_INVOICES_SUCCESS"
export const GET_STOCK_BALANCE_BYSTOCK_FAIL = "GET_INVOICES_FAIL"

export const GET_STOCK_BALANCE_BYMATERIAL = "GET_STOCK_BALANCE_BYMATERIAL"
export const GET_STOCK_BALANCE_BYMATERIAL_SUCCESS = "GET_STOCK_BALANCE_BYMATERIAL_SUCCESS"
export const GET_STOCK_BALANCE_BYMATERIAL_FAIL = "GET_STOCK_BALANCE_BYMATERIAL_FAIL"
